
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.983 11.224a5.626 5.626 0 005.63-5.62C16.613 2.5 14.09 0 10.983 0c-3.109 0-5.63 2.517-5.63 5.603 0 3.087 2.521 5.621 5.63 5.621zM1.243 20h19.549a.736.736 0 00.742-.741c0-3.88-3.16-7.052-7.063-7.052H7.563C3.678 12.207.5 15.362.5 19.259c0 .413.328.741.743.741z"}})])
          )
        }
      }
    